import type { Theme } from "@fluentui/react-components";
import { tokens } from "@fluentui/react-components";

export type CustomAppTheme = Theme & {
  legacy_themeDarker: string;
  legacy_themeDark: string;
  legacy_themeDarkAlt: string;
  legacy_themePrimary: string;
  legacy_themeSecondary: string;
  legacy_themeTertiary: string;
  legacy_themeLight: string;
  legacy_themeLighter: string;

  // neutral colors
  legacy_neutralDark: string;
  legacy_neutralPrimary: string;
  legacy_neutralPrimaryAlt: string;
  legacy_neutralSecondary: string;
  legacy_neutralSecondaryAlt: string;
  legacy_neutralTertiary: string;
  legacy_neutralTertiaryAlt: string;
  legacy_neutralQuaternary: string;
  legacy_neutralQuaternaryAlt: string;
  legacy_neutralLight: string;
  legacy_neutralLighter: string;
  legacy_neutralLighterAlt: string;
  legacy_black: string;
  legacy_white: string;

  // Message Bar colors
  messageBarWarningBackground: string;
  messageBarSuccessBackground: string;
  messageBarErrorBackground: string;
};

export const customTokens: Record<keyof CustomAppTheme, string> = {
  ...tokens,
  legacy_themeDarker: `var(--legacy_themeDarker)`,
  legacy_themeDark: `var(--legacy_themeDark)`,
  legacy_themeDarkAlt: `var(--legacy_themeDarkAlt)`,
  legacy_themePrimary: `var(--legacy_themePrimary)`,
  legacy_themeSecondary: `var(--legacy_themeSecondary)`,
  legacy_themeTertiary: `var(--legacy_themeTertiary)`,
  legacy_themeLight: `var(--legacy_themeLight)`,
  legacy_themeLighter: `var(--legacy_themeLighter)`,

  legacy_neutralDark: `var(--legacy_neutralDark)`,
  legacy_neutralPrimary: `var(--legacy_neutralPrimary)`,
  legacy_neutralPrimaryAlt: `var(--legacy_neutralPrimaryAlt)`,
  legacy_neutralSecondary: `var(--legacy_neutralSecondary)`,
  legacy_neutralSecondaryAlt: `var(--legacy_neutralSecondaryAlt)`,
  legacy_neutralTertiary: `var(--legacy_neutralTertiary)`,
  legacy_neutralTertiaryAlt: `var(--legacy_neutralTertiaryAlt)`,
  legacy_neutralQuaternary: `var(--legacy_neutralQuaternary)`,
  legacy_neutralQuaternaryAlt: `var(--legacy_neutralQuaternaryAlt)`,
  legacy_neutralLight: `var(--legacy_neutralLight)`,
  legacy_neutralLighter: `var(--legacy_neutralLighter)`,
  legacy_neutralLighterAlt: `var(--legacy_neutralLighterAlt)`,
  legacy_black: `var(--legacy_black)`,
  legacy_white: `var(--legacy_white)`,

  messageBarWarningBackground: `var(--messageBarWarningBackground)`,
  messageBarSuccessBackground: `var(--messageBarSuccessBackground)`,
  messageBarErrorBackground: `var(--messageBarErrorBackground)`,
};
